// Mock storage helpers (localStorage). Designed to be replaced by real Laravel API later.

const KEYS = {
  user: "zx_user",
  token: "zx_token",
  profile: "zx_profile",
  meetings: "zx_meetings",
  participations: "zx_participations",
  subscription: "zx_subscription",
  notifications: "zx_notifications",
  settings: "zx_settings",
  registry: "zx_users_registry",
};

export const storage = {
  get(key, fallback = null) {
    try {
      const raw = localStorage.getItem(key);
      return raw ? JSON.parse(raw) : fallback;
    } catch (_) {
      return fallback;
    }
  },
  set(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (_) {}
  },
  remove(key) {
    try {
      localStorage.removeItem(key);
    } catch (_) {}
  },
};

export const STORAGE_KEYS = KEYS;

const delay = (ms = 280) => new Promise((res) => setTimeout(res, ms));
export const mockDelay = delay;

// Initial seed for users registry (so partner search has results)
const SEED_USERS = [
  { id: "u-101", nick: "VelvetMoon", hasPartner: false },
  { id: "u-102", nick: "NocturneOne", hasPartner: false },
  { id: "u-103", nick: "Sirena", hasPartner: false },
  { id: "u-104", nick: "Eclipse", hasPartner: false },
  { id: "u-105", nick: "Carmin", hasPartner: false },
  { id: "u-106", nick: "Obsidian", hasPartner: false },
];

// Initial seed for meetings (random spread around Madrid by default)
const SEED_MEETINGS = [
  {
    id: "m-001",
    organizerId: "u-101",
    organizerNick: "VelvetMoon",
    type: "1+1",
    address: "Calle Secreta 12, Madrid",
    approxLat: 40.4168,
    approxLng: -3.7038,
    exactLat: 40.4172,
    exactLng: -3.7041,
    time: new Date(Date.now() + 1000 * 60 * 60 * 6).toISOString(),
    identifier: "Pañuelo burdeos",
    physicalAttributes: ["Atlético", "Moreno"],
    preferences: ["Discreción", "Velas"],
    interests: ["Bondage suave", "Conversación"],
    status: "open",
    capacity: 1,
    participants: [],
  },
  {
    id: "m-002",
    organizerId: "u-103",
    organizerNick: "Sirena",
    type: "2+2",
    address: "Plaza Oculta 4, Madrid",
    approxLat: 40.4256,
    approxLng: -3.6912,
    exactLat: 40.4259,
    exactLng: -3.6915,
    time: new Date(Date.now() + 1000 * 60 * 60 * 30).toISOString(),
    identifier: "Anillo plateado",
    physicalAttributes: ["Curvy"],
    preferences: ["Suavidad", "Música baja"],
    interests: ["Sensorial"],
    status: "open",
    capacity: 2,
    participants: [],
  },
  {
    id: "m-003",
    organizerId: "u-106",
    organizerNick: "Obsidian",
    type: "1+1",
    address: "Avenida del Susurro 88, Madrid",
    approxLat: 40.4039,
    approxLng: -3.7178,
    exactLat: 40.4035,
    exactLng: -3.7174,
    time: new Date(Date.now() + 1000 * 60 * 60 * 50).toISOString(),
    identifier: "Reloj dorado",
    physicalAttributes: ["Alto"],
    preferences: ["Anonimato"],
    interests: ["Roleplay"],
    status: "closed",
    capacity: 1,
    participants: ["u-104"],
  },
];

const SEED_PLANS = [
  {
    id: "free",
    name: "Iniciado",
    price: 0,
    currency: "EUR",
    period: "mes",
    features: [
      "Mapa con encuentros visibles",
      "Hasta 1 encuentro propio activo",
      "Búsqueda de pareja por nick",
    ],
    popular: false,
  },
  {
    id: "intimate",
    name: "Íntimo",
    price: 9.9,
    currency: "EUR",
    period: "mes",
    features: [
      "Encuentros ilimitados",
      "Filtros avanzados (próximamente)",
      "Notificaciones prioritarias",
      "Radio de búsqueda hasta 100km",
    ],
    popular: true,
  },
  {
    id: "obsidian",
    name: "Obsidiana",
    price: 24.9,
    currency: "EUR",
    period: "mes",
    features: [
      "Todo lo de Íntimo",
      "Identificadores destacados",
      "Verificación de perfil",
      "Soporte VIP discreto",
    ],
    popular: false,
  },
];

const SEED_PLACES = [
  {
    uuid: "p-mad-001",
    hotel_id: "1439964",
    name: "Hotel Urban Madrid",
    url: "https://example.com/h1439964",
    address_locality: "Madrid",
    address_country: "ES",
    scraped: true,
    lat: 40.4195,
    lng: -3.6919,
  },
  {
    uuid: "p-mad-002",
    hotel_id: "2100451",
    name: "Only YOU Hotel Atocha",
    url: "https://example.com/h2100451",
    address_locality: "Madrid",
    address_country: "ES",
    scraped: true,
    lat: 40.4062,
    lng: -3.6895,
  },
  {
    uuid: "p-mad-003",
    hotel_id: "3308122",
    name: "Hotel Óscar",
    url: "https://example.com/h3308122",
    address_locality: "Madrid",
    address_country: "ES",
    scraped: true,
    lat: 40.4241,
    lng: -3.6978,
  },
  {
    uuid: "p-bcn-001",
    hotel_id: "5011223",
    name: "Hotel Casa Fuster",
    url: "https://example.com/h5011223",
    address_locality: "Barcelona",
    address_country: "ES",
    scraped: true,
    lat: 41.3954,
    lng: 2.1619,
  },
  {
    uuid: "p-bcn-002",
    hotel_id: "6123344",
    name: "Hotel Neri Relais & Châteaux",
    url: "https://example.com/h6123344",
    address_locality: "Barcelona",
    address_country: "ES",
    scraped: false,
    lat: 41.3837,
    lng: 2.1763,
  },
];

export { SEED_PLACES };

const SEED_NOTIFICATIONS = [
  {
    id: "n-001",
    title: "Tu solicitud fue aceptada",
    body: "Sirena confirmó tu participación. Ya puedes ver la dirección exacta.",
    createdAt: new Date(Date.now() - 1000 * 60 * 30).toISOString(),
    read: false,
    type: "meeting_accepted",
    link: "/meetings/m-002",
  },
  {
    id: "n-002",
    title: "Nuevo encuentro cerca",
    body: "Un encuentro 1+1 a 4.2km coincide con tus preferencias.",
    createdAt: new Date(Date.now() - 1000 * 60 * 60 * 5).toISOString(),
    read: false,
    type: "nearby",
    link: "/map",
  },
  {
    id: "n-003",
    title: "Bienvenido a ZyrisX",
    body: "Tu identidad permanece oculta. Las direcciones nunca se muestran hasta cerrar el cupo.",
    createdAt: new Date(Date.now() - 1000 * 60 * 60 * 24).toISOString(),
    read: true,
    type: "system",
    link: null,
  },
];

export function ensureSeedData() {
  if (!storage.get(KEYS.registry)) storage.set(KEYS.registry, SEED_USERS);
  if (!storage.get(KEYS.meetings)) storage.set(KEYS.meetings, SEED_MEETINGS);
  if (!storage.get(KEYS.notifications)) storage.set(KEYS.notifications, SEED_NOTIFICATIONS);
  if (!storage.get(KEYS.subscription)) {
    storage.set(KEYS.subscription, {
      currentPlanId: "free",
      status: "active",
      renewsAt: null,
    });
  }
  if (!storage.get(KEYS.settings)) {
    storage.set(KEYS.settings, { searchRadiusKm: 25 });
  }
}

export const SEED = {
  plans: SEED_PLANS,
};
